module.exports = __webpack_public_path__ + "static/media/lusanova.9e6c3b69.jfif";